// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"81c4df18","30":"e0ef11d0","147":"c3841eee","265":"e647a194","442":"91ef2d9f","574":"7371f5c4","807":"8585627e","818":"9d6cbe5b","899":"558ba704","900":"9ab22368","996":"454d89cf"}[chunkId] + ".chunk.js";
};